import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '哥布林的洞窟——探索黑暗地下世界的终极指南',
          description: '哥布林的洞窟是一个充满神秘与危险的地下冒险世界，深度解析背景设定、角色特色、探索攻略与玩法技巧。',
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />

        <section className="py-14 md:py-20 px-4 md:px-6 bg-primary-500">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              准备好开始你的冒险了吗？
            </h2>
            <p className="text-primary-100 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
              哥布林的洞窟深处藏着无数秘密等待勇敢的冒险者去发现。拿起你的武器，点亮你的火把，黑暗洞穴的传奇由你书写。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="/category/beginner-guide"
                className="w-full sm:w-auto px-8 py-3 bg-background-50 text-primary-700 rounded-md font-medium text-sm whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-book-open-line mr-2"></i>查看新手攻略
              </a>
              <a
                href="/about"
                className="w-full sm:w-auto px-8 py-3 border border-background-50/40 text-background-50 rounded-md font-medium text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
              >
                <i className="ri-information-line mr-2"></i>了解更多
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}